<template>
  <div class="fund-Lock">
    <z-collapse :title="$t('loan.fundLock')">
      <template v-slot:action v-if="isChange && !finalLoan">
        <p class="btn-blue" @click="openFund()">{{ $t('btns.changeFund') }}</p>
      </template>
      <ul class="c-list">
        <li><span class="tit">{{ $t('loan.fundLockQuota') }} <i>*</i></span><div class="msg">
          <p v-for="(item,index) in this.dataObj" :key="index"><span>{{ item.lockedCurrency }}&nbsp;{{ item.lockedMoney | formatNum }}</span><span>{{ item.createTime | dateConvert }}</span></p>
        </div></li>
      </ul>
    </z-collapse>
    <!--      资金锁定-->

    <el-dialog :visible.sync="isDialog" :show-close="true" :title="$t('loan.fundAdjust')" custom-class="tipPop tipDialog" width="500px">
      <ul class="c-list edit">
        <li><span class="tit">{{ $t('loan.fundAdjustNum') }}(US$)</span><div class="msg"><el-input :placeholder="$t('financingFundDetail.lockPopTit1')+ availableBalance" v-model.trim="lockNum" maxlength="50" clearable @keyup.native="numInput"/></div></li>
      </ul>
      <!--      锁定金额-->
      <div class="d-foot">
        <el-button @click="cancel">{{ $t('btns.cancel') }}</el-button>
        <el-button type="primary" @click="confirmOne">{{ $t('btns.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--    修改锁定金额-->

    <el-dialog
      :title="$t('financingFundDetail.lockPopTit')"
      :visible.sync="tqTipPopVisible"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="tipPop"
      @closed="tqTipPopVisible = false">
      <i class="tipsIco"/>
      <ul class="listDetail" style="width: 390px; padding-top:42px;">
        <li class="clearfix">
          <div class="item itemL">
            <!--当前资金池可用余额-->
            {{ $t('financingFundDetail.lockPopTit1') }}：
          </div>
          <div class="item itemR"><span class="red">{{ availableBalance | formatNum }} US$</span> </div>
        </li>
        <li class="clearfix">
          <div class="item itemL">
            <!--原融资金额-->
            {{ $t('financingFundDetail.lockPopTit4') }}：
          </div>
          <div class="item itemR"><span class="red">{{ oldLockNum | formatNum }} US$</span> </div>
        </li>
        <li class="clearfix">
          <div class="item itemL">
            <!--本次将锁定-->
            {{ $t('financingFundDetail.lockPopTit2') }}:
          </div>
          <div class="item itemR"><span class="red">{{ lockNum | formatNum }} US$</span></div>
        </li>
        <li class="clearfix">
          <div class="item itemL">
            <!--锁定后余额-->
            {{ $t('financingFundDetail.lockPopTit3') }}：
          </div>
          <div class="item itemR"><span class="red">{{ finalMoney | formatNum }} US$</span></div>
        </li>
      </ul>

      <div slot="footer" class="dialog-footer text-center">
        <div class="centerBtn btn-border-normal" @click="tqTipPopVisible = false">
          <!--取消-->
          {{ $t('btns.cancel') }}
        </div>
        <div class="centerBtn btn-blue" @click="confirm">
          <!--确定-->
          {{ $t('btns.confirm') }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ZCollapse from '../ZCollapse'
import mixins from '@/helper/mixins.js'
export default {
  name: 'FundLock',
  components: {
    ZCollapse
  },
  mixins: [mixins],
  // props:{
  //   fundData:{  // 锁定金额信息
  //     type: Array,
  //   },
  //   isChange:{  // 是否显示 修改金额 按钮
  //     type: Boolean,
  //     default:true
  //   }
  // },
  data() {
    return {
      finalLoan: 0,
      flowNumber: '',
      dataObj: '',
      isDialog: false, // 是否显示 调整锁定金额 弹框
      oldLockNum: '', // 原融资余额
      lockNum: '', //  锁定金额数
      tqTipPopVisible: false, // 修改锁定金额二次弹框
      availableBalance: '',
      finalMoney: '',
      isChange: true
    }
  },
  mounted() {
    this.flowNumber = this.$route.query.f_n || this.$route.query.in_id
  },
  methods: {
    initData(obj) {
      this.finalLoan = parseInt(window.sessionStorage.getItem('finalLoan'))
      this.dataObj = obj.logs
      this.availableBalance = obj.availableBalance
      this.oldLockNum = this.dataObj && this.dataObj.length > 0 && this.dataObj[0].lockedMoney.toFixed(2)
      this.lockNum = this.oldLockNum
      if (obj.isComplete) {
        this.isChange = false
        return false
      }
      // 融资单是否已经完成

      this.checkLimit()
    },
    checkLimit() {
      if (this.isSuper()) {
        this.isChange = true
        return false
      }
      this.getMenu().then(data => {
        this.isChange = data.indexOf(7) > -1
      })
    }, // 校验权限

    openFund() {
      this.isDialog = true
    },
    cancel() {
      this.isDialog = false
    },
    confirmOne() {
      // this.isDialog = false;
      if (!this.lockNum || this.lockNum <= 0 || this.lockNum > this.availableBalance) {
        this.$message.error(this.$t(`financingFundDetail.validPassTip1`))
        return false
      }
      this.tqTipPopVisible = true
      this.finalMoney = parseFloat(this.availableBalance) + parseFloat(this.oldLockNum) - parseFloat(this.lockNum)
      this.finalMoney = this.$utils.convertNum(this.finalMoney, 4)
    },
    confirm() {
      const _this = this
      const params = {
        flowNumber: _this.flowNumber,
        lockedMoney: _this.lockNum
      }
      // console.log(params)
      _this.axios.post('/capital/zmaAdjustLockMoney', params).then(res => {
        // console.log(res);
        if (res.status) {
          _this.$emit('confirm')
          _this.isDialog = false
          _this.tqTipPopVisible = false
        } else if (res.errorCode === 'loan_audit_5000005' || res.errorCode === 'loan_audit_50000031') {
          _this.isDialog = false
          _this.tqTipPopVisible = false
          _this.$emit('confirm')
          _this.checkLimit()
          _this.$message.error(this.$t(`error.${res.errorCode}`))
        } else {
          _this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    },
    numInput() {
      this.lockNum = this.$utils.dealNumber(this.lockNum, 2)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fund-Lock{
    .c-list{
      padding-bottom: 15px;
      .msg{
        span{
          display: inline-block;
          width: 40%;
        }
        p + p{
          padding-top: 20px;
        }
      }
      &.edit{
        padding: 55px 0 60px 0;
        li{
          > .tit{
            color: #81899E;
            width: auto;
          }
          > .msg{
            width: auto;
            flex: 1;
            padding-right: 0;
          }
        }
      }
    }

  }

</style>
